import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromStore from 'src/app/_store/_reducers';
import { AuthService } from 'src/app/_shared/services';
import { InitActions } from 'src/app/_store/_init/actions';
import { NewsActions } from 'src/app/_store/_news/actions';
import { UserActions } from 'src/app/_store/_user/actions';
import { urlToUrlParams } from 'src/app/_shared/helpers/url-params-builder';

@Injectable()
export class InitProvider {
  constructor(private store: Store<fromStore.State>, private authService: AuthService) {}

  load(): Promise<boolean> {
    const Maintenance = localStorage.getItem('isAppInMaintenance') === 'true';

    if (!Maintenance) {
      const url = new URL(window.location.href);
      const mpId = url.searchParams.get('mpId');
      const account = url.searchParams.get('account');
      const pathName = url.pathname;
      return new Promise((resolve) => {
        this.authService.authed.pipe(take(1)).subscribe((payload) => {
          if (payload) {
            if (!payload.isSalesOps || payload.isSalesOps === 'false' || payload.isSysAdmin === 'true') {
              const urlParams = urlToUrlParams(pathName, { mpId: mpId, account: account });
              this.store.dispatch(
                UserActions.setIsSysAdminSuccess({
                  payload: { isSysAdmin: payload.isSysAdmin === 'true' },
                })
              );
              this.store.dispatch(NewsActions.initNews());
              this.store.dispatch(
                InitActions.init({
                  payload: {
                    id: payload.id,
                    accountId: payload.accountId,
                    returnUrl: pathName,
                    isLogin: true,
                    urlParams: urlParams,
                  },
                })
              );
            } else {
              this.store.dispatch(
                InitActions.initSalesOps({
                  payload: {
                    isSalesOps: true,
                  },
                })
              );
            }
            resolve(true);
          } else {
            resolve(true);
          }
        });
      });
    }
  }
}
